var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-col',{staticClass:"mb15",attrs:{"vs-lg":"6","vs-xs":"12"}},[_c('label',{staticClass:"lbl",attrs:{"for":""}},[_vm._v("System City")]),_c('v-select',{attrs:{"label":"name","value":_vm.value,"options":_vm.options},on:{"input":_vm.onChange},model:{value:(_vm.d),callback:function ($$v) {_vm.d=$$v},expression:"d"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }